export default "/build/images/map-marker-good-icon.475222bc.png";